import * as React from 'react'
import { ArrowLeftIcon } from '@radix-ui/react-icons'
import { clsx } from 'clsx'

export const LoginFormResponseContainer = ({
  back,
  children,
  className,
  visible,
}: {
  children?: React.ReactNode
  back: {
    text: string
    handler: () => void
  }
  visible: boolean
  className?: string
}) => {
  return (
    <div
      onKeyDown={(e) => {
        e.stopPropagation()
        if (e.key === 'Escape') back.handler()
      }}
      className={clsx(
        'absolute left-1/2 top-[42%] z-50 flex w-4/5 sm:w-[476px] -translate-x-1/2 flex-col rounded-2xl border border-dark-border bg-dark-base dark:border dark:border-dark-border-solid transition-all duration-300 ease-in-out dark:shadow-modal',
        visible
          ? 'visible -translate-y-1/2 scale-100 opacity-100 shadow-modal'
          : 'invisible translate-y-[calc(-50%+10px)] scale-90 opacity-0',
        className
      )}
    >
      {children}
      <button
        onClick={back.handler}
        className="my-0 inline-flex w-full items-center justify-center border-t border-dark-border-solid py-6 text-sm text-dark-muted transition hover:text-dark-dim"
        aria-label="back to login"
      >
        <ArrowLeftIcon className="mr-1" /> {back.text}
      </button>
    </div>
  )
}
